function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { BlockLoading, InlineLoading } from './BaseLoading';
import { FullLoading } from './FullLoading';
export function Loading(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'full' : _props$type,
      rest = _objectWithoutProperties(props, ["type"]);

  switch (type) {
    case 'full':
      return React.createElement(FullLoading, Object.assign({}, rest));

    case 'block':
      return React.createElement(BlockLoading, Object.assign({}, rest));

    case 'inline':
      return React.createElement(InlineLoading, Object.assign({}, rest));

    default:
      return React.createElement(FullLoading, Object.assign({}, rest));
  }
}
Loading.FullLoading = FullLoading;
Loading.BlockLoading = BlockLoading;
Loading.InlineLoading = InlineLoading;
export default Loading;